import AppointmentReportDashboard from './appointment/appointment-report-dashboard';
import OnlineOrderReportDashboard from './online-order/online-order-report-dashboard';
import ReservationReportDasboard from './reservation/reservation-report-dashboard';

export const ReportRouter = {
  path: 'report',
  children: [
    {
      path: 'reservation',
      element: <ReservationReportDasboard />,
    },
    {
      path: 'appointment',
      element: <AppointmentReportDashboard />,
    },
    {
      path: 'online-order',
      element: <OnlineOrderReportDashboard />,
    },
  ],
};
